import styled from "styled-components"
import multiLineEllipsis from "@irati/ui/src/global/css/multiLineEllipsis"

export default styled.p`
  ${multiLineEllipsis(1)}
`
